import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, tap, catchError } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserCountryRef, UserModel } from '../../../models/user/user.model';
import { SnackbarService } from '../../snackbar.service';
import { API_BASE_URL } from '@app/core/tokens/api-base-url.token';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private API_BASE: string = inject(API_BASE_URL);
  private http: HttpClient = inject(HttpClient);
  private snackbarService: SnackbarService = inject(SnackbarService);
  private translate: TranslateService = inject(TranslateService);
  private router: Router = inject(Router);

  selectedUser = new BehaviorSubject<null | UserModel>(null);

  constructor() {
    const user = localStorage.getItem('user');
    this.selectedUser.next(user ? JSON.parse(user) : null);
  }

  setUser(user: UserModel): void {
    localStorage.setItem('user', JSON.stringify(user));
    this.selectedUser.next(user);
  }

  clearUser(): void {
    localStorage.removeItem('user');
    this.selectedUser.next(null);
  }

  getUsersInfo(): Observable<UserModel | null> {
    return this.http.get<UserModel>(`${this.API_BASE}/users/info`).pipe(
      tap(res => {
        this.setUser(res);
      }),
      catchError(error => {
        console.error('Ошибка при получении информации о пользователе', error);
        this.translate
          .get('Ошибка при получении информации о пользователе')
          .subscribe(translation => {
            this.snackbarService.error(translation);
          });
        this.router.navigate(['/home']);
        localStorage.clear();
        return of(null);
      })
    );
  }

  get countryId(): string {
    const user = this.selectedUser.value;
    if (!user) return '';
    if (typeof user.country === 'string') return user.country;
    const countries = user.country as UserCountryRef[];
    return countries[0]?.id || '';
  }

  get countryIds(): string[] {
    const user = this.selectedUser.value;
    if (!user) return [];
    if (typeof user.country === 'string') return [user.country];
    return (user.country as UserCountryRef[]).map(c => c.id);
  }

  get countries(): UserCountryRef[] {
    const user = this.selectedUser.value;
    if (!user) return [];
    if (typeof user.country === 'string') return [];
    return user.country as UserCountryRef[];
  }
}
